/**
 * Constants for StageTransitionModal — profile types, archetypes, budget
 * buckets, timeframes, payment statuses, archive/lost reasons.
 *
 * ★ MUST MIRROR /app/backend/pipeline_v2.py — keep in sync when either side
 *   changes.
 *
 * Extracted from StageTransitionModal.jsx (2026-07-29 refactor).
 * ★ Fase 32 — label localizzate via i18n (getter → valutate a runtime).
 */
import i18n from '../../i18n';

export const PROFILE_TYPES = [
  { key: 'equity', label: 'Equity Share', icon: '💰' },
  { key: 'real_estate', label: 'Real Estate', icon: '🏠' },
  { key: 'both', label: 'Equity + Real Estate', icon: '🌐' },
];

export const HCF_ARCHETYPES = [
  { key: 'investor', label: 'Investor', icon: '📈', get description() { return i18n.t('stageTransition.arch.investor', 'Cerca ROI puro, attento ai numeri.'); } },
  { key: 'builder', label: 'Builder', icon: '🛠️', get description() { return i18n.t('stageTransition.arch.builder', 'Vuole costruire un asset / eredità.'); } },
  { key: 'operator', label: 'Operator', icon: '⚙️', get description() { return i18n.t('stageTransition.arch.operator', 'Vuole gestire il business in prima persona.'); } },
  { key: 'connector', label: 'Connector', icon: '🤝', get description() { return i18n.t('stageTransition.arch.connector', 'Decide nel gruppo, network-driven.'); } },
];

export const BUDGET_BUCKETS = [
  { key: '<70k', label: '< 70k€' },
  { key: '70-150k', label: '70 – 150k€' },
  { key: '150-300k', label: '150 – 300k€' },
  { key: '300-500k', label: '300 – 500k€' },
  { key: '500k+', label: '500k€ +' },
];

export const TIMEFRAMES = [
  { key: '<3m', get label() { return i18n.t('stageTransition.tf.lt3m', 'Entro 3 mesi'); } },
  { key: '3-6m', get label() { return i18n.t('stageTransition.tf.3to6m', '3 – 6 mesi'); } },
  { key: '6-12m', get label() { return i18n.t('stageTransition.tf.6to12m', '6 – 12 mesi'); } },
  { key: '12m+', get label() { return i18n.t('stageTransition.tf.gt12m', '12 + mesi'); } },
];

export const PAYMENT_STATUSES = [
  { key: 'pending', get label() { return i18n.t('stageTransition.pay.pending', 'In attesa'); } },
  { key: 'partial', get label() { return i18n.t('stageTransition.pay.partial', 'Acconto ricevuto'); } },
  { key: 'paid', get label() { return i18n.t('stageTransition.pay.paid', 'Saldato'); } },
];

// ★ Fase 32 — array valutati a runtime così le voci seguono la lingua attiva.
export const ARCHIVE_REASONS = {
  map(fn) { return this.list().map(fn); },
  list() {
    return [
      i18n.t('stageTransition.archive.notInterested', 'Cliente non interessato'),
      i18n.t('stageTransition.archive.noBudget', 'Budget non sufficiente'),
      i18n.t('stageTransition.archive.badTiming', 'Timing non corretto'),
      i18n.t('stageTransition.archive.competition', 'Concorrenza'),
      i18n.t('stageTransition.archive.noReply', 'Non risponde più'),
      i18n.t('stageTransition.archive.other', 'Altro'),
    ];
  },
};

export const LOST_REASONS = {
  map(fn) { return this.list().map(fn); },
  list() {
    return [
      i18n.t('stageTransition.lost.price', 'Prezzo / Budget'),
      i18n.t('stageTransition.lost.timing', 'Tempistica'),
      i18n.t('stageTransition.lost.competition', 'Concorrenza vinta'),
      i18n.t('stageTransition.lost.changedMind', 'Cambio idea'),
      i18n.t('stageTransition.lost.notQualified', 'Non qualificato'),
      i18n.t('stageTransition.lost.other', 'Altro'),
    ];
  },
};

/**
 * Preset proposal amounts (EUR) for the "proposta_inviata" transition.
 * Displayed as one-click buttons above the free-text field so an Associate
 * can log the proposal amount quickly during a call.
 */
export const PROPOSAL_AMOUNT_PRESETS = [
  15500, 25000, 40000, 70000, 100000, 150000, 300000, 500000,
];

/**
 * Partnership types (for chiuso_partner stage).
 */
export const PARTNERSHIP_TYPES = [
  { key: 'referral', get label() { return i18n.t('stageTransition.partner.referral', 'Referral / Segnalatore'); }, icon: '🤝' },
  { key: 'affiliate', get label() { return i18n.t('stageTransition.partner.affiliate', 'Affiliato / Rivenditore'); }, icon: '💼' },
  { key: 'strategic', get label() { return i18n.t('stageTransition.partner.strategic', 'Partner strategico'); }, icon: '⭐' },
  { key: 'other', get label() { return i18n.t('stageTransition.partner.other', 'Altro'); }, icon: '📎' },
];

/**
 * Pending-show reasons (checkbox list).
 */
export const PENDING_SHOW_REASONS = [
  { key: 'awaiting_docs', get label() { return i18n.t('stageTransition.pending.awaitingDocs', 'In attesa di documenti'); } },
  { key: 'awaiting_decision', get label() { return i18n.t('stageTransition.pending.awaitingDecision', 'Ha chiesto di riflettere'); } },
  { key: 'reschedule', get label() { return i18n.t('stageTransition.pending.reschedule', 'Da rischedulare'); } },
  { key: 'ceo_review', get label() { return i18n.t('stageTransition.pending.ceoReview', 'In review CEO'); } },
];
